import React, { PureComponent } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { withTranslation, WithTranslation } from 'react-i18next'

import { setImageSrc } from '../../store/actions/image.actions'
import Button from '../Common/Buttons/Button/Button'
import Modal from '../Common/Modal/Modal'

/* TODO: Store typings */

type ImageStorePartial = {
  imageSrc: string,
  imageSrcUploaded: string,
  imageData: ImageData
}

type MapStateToProps = {
  imageStore: ImageStorePartial
}

const mapStateToProps = ({
  imageStore: {
    imageSrcUploaded,
    imageData,
    imageSrc
  }
}: MapStateToProps) => ({
  imageSrcUploaded,
  imageData,
  imageSrc
})
const mapDispatchToProps = ({
  dispatchSetImageSrc: (imageSrc: string) => setImageSrc(imageSrc)
})
const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type PrevProjectRestorationProps = WithTranslation & PropsFromRedux & {
  onOpenNew: CallableFunction
}

type PrevProjectRestorationState = {
  isModalOpen: boolean
}

class PrevProjectRestoration extends PureComponent<PrevProjectRestorationProps, PrevProjectRestorationState> {
  state = {
    isModalOpen: false
  }

  shouldHandlePrevImage: boolean

  constructor(props: PrevProjectRestorationProps) {
    super(props)

    this.shouldHandlePrevImage = !!this.props.imageSrcUploaded
  }

  componentDidUpdate(prevProps: PrevProjectRestorationProps) {
    const {
      imageData,
      imageSrc
    } = this.props

    // when the image can't be downloaded because of an error, imageSrc gets cleared
    if (this.shouldHandlePrevImage && !imageSrc && prevProps.imageSrc) {
      this.shouldHandlePrevImage = false
    }

    if (this.shouldHandlePrevImage && imageData && !prevProps.imageData) {
      this.shouldHandlePrevImage = false

      this.setState({
        isModalOpen: true
      })
    }
  }

  componentDidMount() {
    const {
      imageSrcUploaded,
      dispatchSetImageSrc
    } = this.props

    if (imageSrcUploaded) {
      dispatchSetImageSrc(imageSrcUploaded)
    }
  }

  onModalClose = () => {
    this.setState({
      isModalOpen: false
    })
  }

  onOpenNew = () => {
    const { onOpenNew } = this.props

    this.setState({
      isModalOpen: false
    })

    onOpenNew()
  }

  render() {
    const { isModalOpen } = this.state
    const { t } = this.props

    return (
      <Modal isOpen={isModalOpen} onCloseModal={this.onModalClose}>
        <div className="modal__body">
          {t('modals.continue-editing')}
        </div>
        <div className="modal__buttons">
          <Button variant="ghost" onClick={this.onOpenNew}>
            {t('buttons.open-new-photo')}
          </Button>
          <div className="modal__buttons-separator" />
          <Button onClick={this.onModalClose}>
            {t('buttons.continue-editing')}
          </Button>
        </div>
      </Modal>
    )
  }
}

export default withTranslation()(connector(PrevProjectRestoration))
